import { NgModule } from 'ng-metadata/core';
import {PrimolyticsService} from './primolytics.service';
import {PrmPerformanceMonitor} from "./performanceMonitor/performanceMonitor.directive";

@NgModule({
    declarations: [
        PrmPerformanceMonitor
    ],
    providers: [
        PrimolyticsService

    ],
    imports:[
    ]
})
export class PrimolyticsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/analytics/primolytics.module.ts